import React, {useRef, useState} from "react";
import connect from "react-redux/es/connect/connect";
import Points from "../../common/Points";
import Currency from "../../common/Currency";
import Container from "react-bootstrap/Container";
import RebagRewardsProgressBar from "../../common/RebagRewardsProgressBar";
import {copyToClipboard} from "../../common/utils";
import Button from "react-bootstrap/Button";
import config from "../../../config";
import NumberFormat from "react-number-format";
import TransactBefore from "../../common/TransactBefore";

const TierDetails = ({user_profile, rewards_tiers, isInternational}) => {
    const {tier, points, pending_points, life_time_transaction_value} = user_profile;
    const {expiration_date, next_tier_key, tier_key, value_needed_for_next_level, special_discount} = tier;

    const codeSelectHelper = useRef(null);
    const [copy_status, setCopyStatus] = useState("Copy here");
    const copyText = (e) => {
        copyToClipboard(e, codeSelectHelper);
        setCopyStatus("Copied!");
    };

    return (
        <Container className="personalization__returning-user-rewards">
            {life_time_transaction_value >= 300 && !isInternational &&
            <div className="returning-user-rewards__container">
                <div className="returning-user-rewards__box">
                    <div className="returning-user-rewards__box-left">
                        <div className="returning-user-rewards__title">Your Points</div>
                        <div className="returning-user-rewards__text">
                            <TransactBefore expiration_date={expiration_date}/>
                        </div>
                        <div className="returning-user-rewards__tier-container">
                            <NumberFormat value={points} displayType={'text'} thousandSeparator={true} className="returning-user-rewards__big-text"/> <span className="returning-user-rewards__points-suffix">Points</span>
                        </div>
                        {pending_points > 0 &&
                        <div className="returning-user-rewards__subtitle">
                            You have <Points value={pending_points} /> pending
                        </div>
                        }
                        {pending_points > 0 && special_discount && special_discount.code &&
                        <div className="returning-user-rewards__text returning-user-rewards__code-text">
                            <input ref={codeSelectHelper} type="hidden" value={special_discount.code}/>
                                Code: {special_discount.code} - apply at checkout to<br /> receive {special_discount.percentage}% off your purchase. <Button
                                onClick={copyText}
                                className="rbg-link rbg-link--inline acc-rebag-rewards__text"
                                variant="clean"
                            >
                                {copy_status}
                            </Button>
                        </div>
                        }
                    </div>
                    <div className="returning-user-rewards__box-right">
                        <div className="returning-user-rewards__title">Your Status</div>
                        {value_needed_for_next_level > 0 &&
                        <div className="returning-user-rewards__text">
                            Spend <Currency value={value_needed_for_next_level}/> to
                            reach {rewards_tiers[next_tier_key].name}<br/> level. <a
                                href={`${config.host_rebag}/rewards`}
                                className="rbg-link rbg-link--inline acc-rebag-rewards__text"
                                target="_blank"
                                rel="noopener noreferrer"
                            >
                                Learn about benefits
                            </a>
                        </div>
                        }
                        <div className="returning-user-rewards__tier-container">
                            <span className="returning-user-rewards__big-text">
                                {tier_key === "no_tier" ? "You're close!" : rewards_tiers[tier_key].name}
                            </span>
                        </div>
                        {tier_key !== "no_tier" &&
                            <div className={`rr-tier-icon rr-tier-icon--${tier_key}`}/>
                        }
                        <RebagRewardsProgressBar
                            user_profile={user_profile}
                            rewards_tiers={rewards_tiers}
                            custom_class="rr-summary__progress--smaller"
                        />
                        <span className="returning-user-rewards__small-text">Lifetime Transactions</span>
                    </div>
                </div>
            </div>
            }
            <div className="returning-user-rewards__buttons-container">
                <Button
                    className="returning-user-rewards__button returning-user-rewards__button--view rbg-btn-black"
                    variant="clean"
                    href={`${config.host_rebag}/my-account/rebag-rewards`}
                >
                    View My Rewards
                </Button>
                {tier_key === "no_tier" && tier_key === "tier_1" &&
                <Button
                    className="returning-user-rewards__button rbg-btn-ghost"
                    variant="clean"
                    href=""
                >
                    Access VIP Preview
                </Button>
                }
            </div>
        </Container>
    )
}

const mapStateToProps = function (state) {
    const { isInternational } = state.appReducer;
    return { isInternational };
};

export default connect(mapStateToProps, null)(TierDetails);